import { PromiseVoidFunction } from '@dreryk/react-common';

import { GynecologicalInterviewSidePanelList } from './GynecologicalInterviewSidePanelList';
import { GynecologicalInterviewSidePanelListLoader } from './GynecologicalInterviewSidePanelList.loader';

type GynecologicalInterviewSidePanelContentProps = {
   readonly patientId: number;
   readonly onMedicalDataAccessAuthorizationUpdate: PromiseVoidFunction;
};

export const GynecologicalInterviewSidePanelContent = (
   props: GynecologicalInterviewSidePanelContentProps
): JSX.Element => {
   return (
      <GynecologicalInterviewSidePanelListLoader patientId={props.patientId}>
         {({ gynecologicalInterviews }) => (
            <GynecologicalInterviewSidePanelList
               gynecologicalInterviews={gynecologicalInterviews}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         )}
      </GynecologicalInterviewSidePanelListLoader>
   );
};
